import { Popover, Transition } from "@headlessui/react";
import { Fragment, ReactElement, useState } from "react";

export default function Tooltip({
  children,
  title,
  description,
  fitContent,
  className,
  classNameWrapper,
  position,
  descriptionReact,
}: {
  children: ReactElement;
  title?: string;
  description: string | ReactElement;
  fitContent?: boolean;
  className?: string;
  classNameWrapper?: string;
  position?: "left" | "right";
  descriptionReact?: ReactElement;
}) {
  const [isOpen, setIsOpen] = useState(false);
  let timeout: any;
  return (
    <Popover
      className={"relative " + (classNameWrapper ? classNameWrapper : "")}
      onMouseEnter={() => {
        setIsOpen(true);
        clearTimeout(timeout);
      }}
      onMouseLeave={() => {
        timeout = setTimeout(() => setIsOpen(false), 50);
      }}
    >
      {() => (
        <>
          <Popover.Button className={className ? className : ""}>
            {children}
          </Popover.Button>
          <Transition
            show={isOpen}
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel
              className={`absolute overflow-visible z-10  px-4 mt-3 transform ${
                position
                  ? position == "left"
                    ? "-translate-x-1/2 left-1/2"
                    : ""
                  : "-translate-x-1/2 left-1/2"
              } sm:px-0 lg:max-w-sm ${fitContent ? "w-min " : "w-max"}`}
            >
              <div className="overflow-hidden rounded-lg w-64 shadow-lg border border-border">
                {descriptionReact ? (
                  descriptionReact
                ) : (
                  <div className="p-4 bg-white">
                    {title && (
                      <span className="flex items-center">
                        <span className="text-sm font-medium text-gray-900">
                          {title}
                        </span>
                      </span>
                    )}
                    <span className="block text-sm text-gray-500">
                      {description}
                    </span>
                  </div>
                )}
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
